import React from "react";
import { C, RARITY } from "../../constants/design";
import { FLAG } from "../../constants/matches";

export const COIN_ICON = "https://pub-fe12241b7bb041a784ec4049e068ea80.r2.dev/CoinIcon.png";

export const Fl = ({ team, size = 22 }: { team: string; size?: number }) => (
  <span style={{ fontSize: size, lineHeight: 1 }}>{FLAG[team] || "🏳️"}</span>
);

export const Coin = ({ n }: { n: number }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      color: C.gold,
      fontWeight: 800,
    }}
  >
    <img src={COIN_ICON} alt="" style={{ width: 14, height: 14, objectFit: "contain" }} /> {n.toLocaleString("en-US")}
  </span>
);

export const RChip = ({ rarity, sm }: { rarity: string; sm?: boolean }) => {
  const r = RARITY[rarity as keyof typeof RARITY];
  return (
    <span
      style={{
        fontSize: sm ? 9 : 10,
        fontWeight: 800,
        letterSpacing: 0.4,
        textTransform: "uppercase",
        color: r.color,
        border: `1px solid ${r.color}`,
        borderRadius: 999,
        padding: sm ? "1px 6px" : "2px 8px",
        background: `${r.color}1A`,
      }}
    >
      {r.label}
    </span>
  );
};

export const LiveBadge = () => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 5,
      fontSize: 10.5,
      fontWeight: 900,
      color: C.live,
      background: `${C.live}1F`,
      border: `1px solid ${C.live}77`,
      borderRadius: 999,
      padding: "2px 8px",
    }}
  >
    <span
      style={{
        width: 7,
        height: 7,
        borderRadius: 999,
        background: C.live,
        animation: "blink 1s infinite",
      }}
    />{" "}
    LIVE
  </span>
);

export const Toast = ({ msg }: { msg: string }) => (
  <div
    style={{
      position: "fixed",
      bottom: 80,
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 60,
      background: C.surface2,
      border: `1px solid ${C.line}`,
      color: C.text,
      padding: "10px 16px",
      borderRadius: 12,
      fontSize: 13,
      fontWeight: 600,
      boxShadow: "0 10px 30px rgba(0,0,0,.5)",
      animation: "slideUp .25s ease",
      maxWidth: 320,
      textAlign: "center",
    }}
  >
    {msg}
  </div>
);

export function DayLabel({ date, count }: { date: string; count: number }) {
  const txt = new Date(date + "T12:00:00Z").toLocaleDateString("en-US", {
    timeZone: "Asia/Seoul",
    weekday: "long",
    day: "numeric",
    month: "long",
  });
  return (
    <div
      style={{
        display: "flex",
        alignItems: "baseline",
        gap: 8,
        margin: "0 2px 9px",
      }}
    >
      <span
        className="d"
        style={{ fontSize: 15, fontWeight: 900, textTransform: "capitalize" }}
      >
        {txt}
      </span>
      <span style={{ fontSize: 11, color: C.faint, fontWeight: 700 }}>
        {count} match{count > 1 ? "s" : ""}
      </span>
    </div>
  );
}

export function SH({
  title,
  sub,
  children,
  style,
}: {
  title: string;
  sub?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
        margin: "4px 2px 11px",
        ...style,
      }}
    >
      <div>
        <h2
          className="d"
          style={{
            fontWeight: 900,
            fontSize: 18,
            margin: 0,
            letterSpacing: -0.2,
          }}
        >
          {title}
        </h2>
        {sub && (
          <div style={{ fontSize: 11.5, color: C.muted, marginTop: 1 }}>
            {sub}
          </div>
        )}
      </div>
      {children}
    </div>
  );
}
